import { render, staticRenderFns } from "./FloatingControls.vue?vue&type=template&id=767a4def&scoped=true"
import script from "./FloatingControls.vue?vue&type=script&lang=js"
export * from "./FloatingControls.vue?vue&type=script&lang=js"
import style0 from "./FloatingControls.vue?vue&type=style&index=0&id=767a4def&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767a4def",
  null
  
)

export default component.exports